
















import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { State, Action, namespace } from 'vuex-class'
import { YKDModal } from 'gum-ui'
import PunchCard from '@/apps/ice/pages/studyplan/PunchCard.vue'

const ModuleStudyPlan = namespace('app-ice/studyPlan')

@Component({
  components: {
    YKDModal,
    PunchCard
  }
})
export default class StudyPlanImageModal extends Vue {
  @ModuleStudyPlan.State(state => state.shareModal)
  private shareModal!: any
  @ModuleStudyPlan.Action('controlShareModal')
  controlShareModal!: Function

  closeModal() {
    if (this.shareModal) {
      this.controlShareModal({
        visible: false,
        url: this.shareModal.url
      })
    }
  }
}
